import { createSlice } from "@reduxjs/toolkit";
const popupSlice = createSlice({
  name: "popup",
  initialState: {
    returningPopup: false,
    guestNumber: 1,
    programPopup: false,
    accommodationPopup: false,
  },
  reducers: {
    setProgramPopupHide(state) {
      state.programPopup = false;
    },
    setProgramPopupShow(state) {
      state.programPopup = true;
    },
    setAccommodationPopupHide(state) {
      state.accommodationPopup = false;
    },
    setAccommodationPopupShow(state) {
      state.accommodationPopup = true;
    },
    setReturningPopupShowGuestOne(state) {
      state.guestNumber = 1;
      state.returningPopup = true;
    },
    setReturningPopupShowGuestTwo(state) {
      state.guestNumber = 2;
      state.returningPopup = true;
    },
    setReturningPopupHide(state) {
      state.returningPopup = false;
    },
  },
});

export const popupActions = popupSlice.actions;

export default popupSlice;
